import styled from 'styled-components'

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
  padding: 10px;

  * {
    color: ${({ theme }) => theme.colors.primary} !important;
    font-size: 13px !important;
    min-height: 0 !important;
  }
`

export const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
export const NavigationPagesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

export const RangeSelectorWrapper = styled.div`
  width: 100%;
`
export const RangeSelectorContainer = styled.div`
  width: fit-content;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.secondary};
`

export const SummaryContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  text-align: end;
  padding: 5px 10px;
`
